import { cn } from "@/lib/utils";

/**
 * Visual tone for the icon-button trigger of the Theme/Language toggles.
 * - "default": light-surface outline (app-shell TopAppBar / Profile).
 * - "onDark": transparent button with a light icon + subtle white border, for
 *   deep-blue surfaces like the landing/login navbar where the default white
 *   outline would render as an invisible white box.
 */
export type ToggleTone = "default" | "onDark";

const ON_DARK_TRIGGER =
  "border-white/25 bg-transparent text-white hover:bg-white/10 hover:text-white";

/** Trigger className for a toggle's surface tone (icon size + onDark overrides). */
export function toggleTriggerClass(tone: ToggleTone): string {
  return cn("h-9 w-9", tone === "onDark" && ON_DARK_TRIGGER);
}
